const Nav = () => {
  const breakpoint = 1020;

  const elements = {
    navToggle: document.querySelector('.navbar-toggler'),
    collapseNav: document.getElementById('collapseNav'),
    menuItems: document.querySelectorAll('.menu-item-has-children'),
    subMenuContainer: document.getElementById('subMenu'),
    subMenuWrapper: document.querySelector('.nav-sub-menu'),
  };

  let isMobile = window.innerWidth < breakpoint;

  const addSubmenuToggles = () => {
    const items = document.querySelectorAll('.menu-item-has-children');

    items.forEach((item) => {
      const link = item.querySelector('a');
      if (!link) return;

      // Avoid duplicating if already added
      if (item.querySelector('.submenu-toggle')) return;

      const button = document.createElement('button');
      button.className = 'submenu-toggle';
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('type', 'button');

      // simple chevron (replace with icon if you want)
      button.innerHTML = '<span class="chevron"></span>';

      link.after(button);
    });
  };

  /**
   * MOBILE: Toggle main nav
   */
  const handleMobileToggle = () => {
    if (!elements.navToggle || !elements.collapseNav) return;

    elements.navToggle.addEventListener('click', (e) => {
      e.preventDefault();

      const isOpen = elements.collapseNav.classList.contains('show');

      if (isOpen) {
        elements.collapseNav.classList.remove('show');
        elements.navToggle.setAttribute('aria-expanded', 'false');
      } else {
        elements.collapseNav.classList.add('show');
        elements.navToggle.setAttribute('aria-expanded', 'true');
      }
    });
  };

  /**
   * MOBILE: Toggle submenus (tap behavior)
   */
  const handleMobileSubmenus = () => {
    const toggles = document.querySelectorAll('.submenu-toggle');

    toggles.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        if (!isMobile) return;

        e.preventDefault();
        e.stopPropagation();

        const item = btn.closest('.menu-item-has-children');
        if (!item) return;

        const isOpen = item.classList.contains('open');

        // close all others
        elements.menuItems.forEach((i) => {
          if (i !== item) {
            i.classList.remove('open');

            const otherBtn = i.querySelector('.submenu-toggle');
            if (otherBtn) {
              otherBtn.setAttribute('aria-expanded', 'false');
            }
          }
        });

        // toggle current
        item.classList.toggle('open');

        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      });
    });
  };

  /**
   * DESKTOP: Hover behavior
   */
  const handleDesktopHover = () => {
    elements.menuItems.forEach((item) => {
      item.addEventListener('mouseenter', () => {
        if (isMobile) return;

        const subMenu = item.querySelector('.sub-menu');
        if (!subMenu) return;

        elements.subMenuContainer.innerHTML = subMenu.innerHTML;
        // elements.subMenuWrapper.style.display = 'block';
      });
    });

    const main = document.querySelector('#main');
    
    if (main) {
      main.addEventListener('mouseenter', () => {
        if (isMobile) return;

        // elements.subMenuWrapper.style.display = 'none';
        elements.subMenuContainer.innerHTML = '';
      });
    }
  };

  const handleSearch = () => {
    const searchLink = document.querySelector('.search-link a');
    const searchForm = document.getElementById('collapseSearchForm');

    if (!searchLink || !searchForm) return;

    // Click toggle (desktop only behavior)
    searchLink.addEventListener('click', (e) => {
      if (isMobile) return;

      e.preventDefault();

      if (searchForm.style.display === 'block') {
        searchForm.style.display = 'none';
      } else {
        searchForm.style.display = 'block';
      }
    });
  };

  /**
   * Handle breakpoint switching
   */
  const handleResize = () => {
    const newIsMobile = window.innerWidth < breakpoint;

    if (newIsMobile !== isMobile) {
      isMobile = newIsMobile;

      // Reset nav state
      elements.menuItems.forEach((item) => item.classList.remove('open'));

      if (elements.subMenuWrapper) {
        elements.subMenuWrapper.style.display = 'none';
      }

      if (elements.collapseNav) {
        elements.collapseNav.classList.remove('show');
      }
    }

    // Search behavior per breakpoint
    const searchForm = document.getElementById('collapseSearchForm');

    if (searchForm) {
      if (isMobile) {
        searchForm.style.display = 'block';
      } else {
        searchForm.style.display = 'none';
      }
    }
  };

  /**
   * INIT
   */
  const init = () => {
    addSubmenuToggles();
    handleMobileToggle();
    handleMobileSubmenus();
    handleDesktopHover();
    handleSearch();
    handleResize();

    window.addEventListener('resize', handleResize);
  };

  init();
};

export default Nav;